<div class="strategy-area">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-6 col-md-12">
                <div class="strategy-image">
                    <img src="assets/images/1925x625.avif" alt="image">
                </div>
            </div>
            <div class="col-lg-6 col-md-12">
                <div class="strategy-content pt-5">
                    <div class="section-title pt-4">
                        <h4>{{ 'strategy.kicker' | translate }}</h4>
                        <h3>{{ 'strategy.title' | translate }} <span>{{ 'strategy.highlight' | translate }} </span></h3>
                        <p  class="pt-3">{{ 'strategy.p1' | translate }}</p>
                    </div>
                    <ul hidden class="features-list">
                        <li><i class="fa fa-check"></i>Multiplataforma</li>
                        <li><i class="fa fa-check"></i>Multiambiente</li>
                        <li><i class="fa fa-check"></i>Sobre diversos tipos
                            de lenguajes con énfasis en software libre</li>
                        <li><i class="fa fa-check"></i>Sobre bases de datos centralizas y descentralizadas</li>
                        <li><i class="fa fa-check"></i>Orientadas a Mcroservicios</li>
                        <li><i class="fa fa-check"></i>Ingeniería en la nube</li>
                        <li><i class="fa fa-check"></i>Web / Mobile/ Standalone</li>
                    </ul>
                    <p>{{ 'strategy.p2' | translate }}</p>

                </div>
                <div class="strategy-content pt-4">
                    <div class="section-title">
                        <h3>{{ 'strategy.commitmentTitle' | translate }} <span>{{ 'strategy.commitmentHighlight' | translate }} </span></h3>
                        <p class="pt-3">{{ 'strategy.commitmentText' | translate }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="shape1"><img src="assets/img/shape1.png" alt="image"></div>
</div>
